export default [ {
  path: '/yuangongquan',
  name: 'yuangongquan',
  redirect: {
    name: 'yuangongquanList'
  },
  meta: {
    title: '邮工圈',
    NeedLogin: false,
    keepAlive: false
  },
  component: resolve => {
    require(['../views/yuangongquan/index'], resolve)
  },
  children: [{
    path: 'list',
    name: 'yuangongquanList',
    meta: {
      title: '邮工圈',
      NeedLogin: false,
      isUseCache: false,
      keepAlive: true
    },
    component: resolve => {
      require(['../views/yuangongquan/list'], resolve)
    }
  }, {
    path: 'detail/:id',
    name: 'yuangongquanDetail',
    meta: {
      title: '邮工圈',
      NeedLogin: false,
      keepAlive: false
    },
    component: resolve => {
      require(['../views/yuangongquan/detail'], resolve)
    }
  }, {
    path: 'addMoments',
    name: 'yuangongquanAddMoments',
    meta: {
      title: '编辑内容',
      NeedLogin: false,
      keepAlive: false
    },
    component: resolve => {
      require(['../views/yuangongquan/addMoments'], resolve)
    }
  }, {
    path: 'my/:id',
    name: 'yuangongquanMy',
    meta: {
      title: '我的',
      NeedLogin: false,
      keepAlive: false
    },
    component: resolve => {
      require(['../views/yuangongquan/my'], resolve)
    }
  }, {
    path: 'userlist/:id',
    name: 'yuangongquanUserlist',
    meta: {
      title: '邮工圈',
      NeedLogin: false,
      keepAlive: false
    },
    component: resolve => {
      require(['../views/yuangongquan/my'], resolve)
    }
  }, {
    path: 'message',
    name: 'yuangongquanMessage',
    meta: {
      title: '消息',
      NeedLogin: false,
      isUseCache: false,
      keepAlive: true
    },
    component: resolve => {
      require(['../views/yuangongquan/message'], resolve)
    }
  }, {
    path: 'report/:id',
    name: 'yuangongquanReport',
    meta: {
      title: '举报',
      NeedLogin: false,
      keepAlive: false
    },
    component: resolve => {
      require(['../views/yuangongquan/report'], resolve)
    }
  }]
}]
